import {Pipe, PipeTransform} from '@angular/core';

/*

let ;

return function (item, sortKey) {

  let item_sortKey;
  item_sortKey = itemSecondary(item, sortKey);
  if (typeof sortKey === 'undefined') item_sortKey = item;
  return item_sortKey;
}
*/


@Pipe({
  name: 'dotNotationExtractor'
})
export class DotNotationExtractorPipe implements PipeTransform {
  private itemSecondary(item, sortKey) {
    function index(accumulator, current) {
      if (accumulator) {return accumulator[current];}
    }

    if (sortKey) {return sortKey.split('.').reduce(index, item);}
    else {return item;}
  }

  transform(value: any, dotNotaion: string): any {
    return this.itemSecondary(value, dotNotaion);
  }

}
